import { z } from 'zod';
import { tradeIdSchema } from './trade-state/TradeId.ts';
const numericRecordKeySchema = z.coerce.number().int().nonnegative();
export const AT_LEAST_ONE_ENTRY_MESSAGE = 'At least one entry must be provided';
export function createNumericKeyRecordSchema(valueSchema, options) {
    const base = z.record(numericRecordKeySchema, valueSchema);
    if (options === null || options === void 0 ? void 0 : options.requireAtLeastOneEntry) {
        return base.refine((obj)=>Object.keys(obj).length > 0, {
            message: AT_LEAST_ONE_ENTRY_MESSAGE
        });
    }
    return base;
}
export function createTradeIdKeyRecordSchema(valueSchema, options) {
    const base = z.record(tradeIdSchema, valueSchema);
    if (options === null || options === void 0 ? void 0 : options.requireAtLeastOneEntry) {
        return base.refine((obj)=>Object.keys(obj).length > 0, {
            message: AT_LEAST_ONE_ENTRY_MESSAGE
        });
    }
    return base;
}
export function createKeyRecordSchema(keys, valueSchema, options) {
    const shape = {};
    keys.forEach((key)=>{
        shape[key] = valueSchema.exactOptional();
    });
    const base = z.object(shape).strict();
    if (options === null || options === void 0 ? void 0 : options.requireAtLeastOneEntry) {
        return base.refine((obj)=>Object.keys(obj).length > 0, {
            message: AT_LEAST_ONE_ENTRY_MESSAGE
        });
    }
    return base;
}
